const MailOpened = () => (
  <>
    <path
      fill="currentColor"
      d="m12.833 2.677 7.679 4.57q.219.159.354.393t.134.51v10.234q0 .69-.462 1.154a1.57 1.57 0 0 1-1.154.462H4.616q-.69 0-1.153-.462A1.57 1.57 0 0 1 3 18.384V8.15q0-.274.135-.51.134-.234.354-.394l7.678-4.569q.379-.218.833-.218t.833.218m-.525 9.78L19.8 8l-7.492-4.458A.6.6 0 0 0 12 3.446a.6.6 0 0 0-.308.096L4.2 8l7.492 4.458a.6.6 0 0 0 .308.096.6.6 0 0 0 .308-.096m-1.14.86L4 9.047v9.337a.6.6 0 0 0 .173.443.6.6 0 0 0 .442.173h14.77a.6.6 0 0 0 .442-.173.6.6 0 0 0 .173-.443V9.047l-7.167 4.271q-.379.217-.833.217t-.833-.217M12.832 19H20 4z"
    />
  </>
)
export default MailOpened
